<div class="modal-header border-0">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-4 mt-3"
		>Détails restitution</span
	>
	<button
		type="button"
		class="btn-close custom-button-close border border-white rounded-circle bg-white fs-4"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
	<div class="">
		<button
			class="btn theme-main-color-button mx-3 px-3"
			(click)="editForm()"
		>
		<i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier
		</button>
	</div>
	<div class="">
		<a
			(click)="openModal(deleteActivity)"
			class="btn theme-red-button px-4"
		>
			Supprimer
		</a>
	</div>
</div>
<div class="modal-body" style="overflow: visible;">
	<div *ngIf="isFormReadOnly" class="row">
		<div class="">
			<div class="row" style="overflow: visible;">
				<div class="row mt-4 px-lg-5 px-2">
					<span class="theme-main-color fs-4 col">Informations</span>
					<!-- <a
						[routerLink]="['/gestion/formations', missionRequest?.id]"
						[queryParams]="{ redirected: true }"
						class="btn col-4 theme-main-color-button"
						(click)="bsModalRef.hide()"
						><i class="bi bi-pencil-fill px-1" aria-hidden="true"></i>Modifier le suivi</a
					> -->
				</div>
			</div>
			<div class="row my-5 px-lg-5 px-2" style="overflow: visible;">
				<div class="col-12">
					<div class="row my-4">
						<div class="col-6">
							<span
								for="type"
								class="theme-main-color fw-bold form-label row my-2"
								>Type de restitution</span
							>
							<span class="row my-2" id="type">{{
								ResitutionTypeEnumString[restitutionPrestation?.type]
							}}</span>
						</div>
						<div class="col-6">
							<span
								for="dateDepotRestFinale"
								class="theme-main-color fw-bold form-label row my-2"
								>Date de dépôt de restitution finale</span
							>
							<span class="row my-2" id="dateDepotRestFinale">{{
								restitutionPrestation?.dateDepotRestFinale | date : 'dd/MM/yyyy'
							}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="prolongation"
								class="theme-main-color fw-bold form-label row my-2"
								>Demande de prolongation de la durée :
							</span>
							<span class="row my-2" id="prolongation">{{restitutionPrestation.prolongation ? 'Oui' : 'Non'}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="date1erRv"
								class="theme-main-color fw-bold form-label row my-2"
								>Date de 1er rendez-vous bénéficiaire</span
							>
							<span class="row my-2" id="date1erRv">{{
								restitutionPrestation?.date1erRv | date : 'dd/MM/yyyy'
							}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="dateFinPrev"
								class="theme-main-color fw-bold form-label row my-2"
								>Nouvelle date de fin prévisionnelle de réalisation</span
							>
							<span class="row my-2" id="dateFinPrev">{{
								restitutionPrestation?.dateFinPrev | date : 'dd/MM/yyyy'
							}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="heuresPrev"
								class="theme-main-color fw-bold form-label row my-2"
								>Heures prévisionnelles de réalisation
							</span>
							<span class="row my-2" id="heuresPrev">{{
								restitutionPrestation?.heuresPrev
							}}</span>
						</div>
						<div class="col-6">
							<span
								for="totalHeures"
								class="theme-main-color fw-bold form-label row my-2"
								>Totale heures renseignées
							</span>
							<span class="row my-2" id="totalHeures">{{
								restitutionPrestation?.totalHeures
							}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="totalHeuresRestantes"
								class="theme-main-color fw-bold form-label row my-2"
								>Totale heures restantes
							</span>
							<span class="row my-2" id="totalHeuresRestantes">{{
								restitutionPrestation?.totalHeuresRestantes
							}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="mobilisationAutreAs"
								class="theme-main-color fw-bold form-label row my-2"
								>Mobilisation autre appui spécifique :
							</span>
							<span class="row my-2" id="mobilisationAutreAs">{{restitutionPrestation.mobilisationAutreAs ? 'Oui' : 'Non'}}</span>
						</div>
						<div class="col-6">
							<span
								for="statutDemandeProlongation"
								class="theme-main-color fw-bold form-label row my-2"
								>Demande de prolongation de la durée :
							</span>
							<span class="row my-2" id="statutDemandeProlongation">{{StatutProlongationEnumString[restitutionPrestation.statutDemandeProlongation]}}</span>
						</div>
					</div>
					<div class="row my-4">
						<div class="col-6">
							<span
								for="demarcheAdministrative"
								class="theme-main-color fw-bold form-label row my-2"
								>Démarche administrative à conduire :
							</span>
							<span class="row my-2" id="demarcheAdministrative">{{restitutionPrestation.demarcheAdministrative ? 'Oui' : 'Non'}}</span>
							<span class="row my-2" id="demarcheAdministrativeDetails">{{restitutionPrestation.demarcheAdministrativeDetails}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<app-restitutionPrestation-form
				*ngIf="!isFormReadOnly"
				[restitutionPrestation]="restitutionPrestation"
				[isAddForm]="false"
				[form]="form"
				[isValidateButtonClicked]="isValidateButtonClicked"
				(sendForm)="onSubmit()"
	>
	</app-restitutionPrestation-form>
	<div class="row my-4">
		<div class="d-flex justify-content-end">
			<button
				*ngIf="!isFormReadOnly"
				class="btn theme-main-color-button mx-3 px-3"
				(click)="stopEditForm()"
			>
				Annuler
			</button>
			<button
				*ngIf="!isFormReadOnly"
				[disabled]="!form.valid || isValidateButtonClicked.value"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</div>
<ng-template #deleteActivity>
	<div class="modal-header text-center">
		<h4>Suppression</h4>
		<button
			type="button"
			class="btn-close pull-right"
			data-bs-dismiss="modal"
			aria-label="Close"
			(click)="confirmDeleteModalRef.hide()"
		></button>
	</div>
	<div class="modal-body">
		Êtes-vous sûr de vouloir effectuer la suppression ?
	</div>
	<div class="modal-footer">
		<a
			(click)="confirmDeleteModalRef.hide()"
			class="btn theme-main-color-button"
			>Retour</a
		>
		<a class="btn theme-red-button ms-3" (click)="delete(restitutionPrestation)"
			>Supprimer</a
		>
	</div>
</ng-template>